import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;
    if (!session_id) {
      navigate("/login", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id }, { withCredentials: true })
      .then((r) => {
        // Clear the hash so refreshing won't re-process
        window.history.replaceState({}, document.title, window.location.pathname);
        setUser(r.data);
        toast.success("Bienvenido");
        navigate("/", { replace: true, state: { user: r.data } });
      })
      .catch(() => {
        toast.error("Autenticación fallida");
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] text-stone-500">
      Autenticando...
    </div>
  );
}
